import { DatePipe } from '@angular/common';
import { AppConsts } from '../../AppConsts';

export function getAppDateFormatPattern(): string {
    if (!AppConsts.dateFormatId) {
        return 'MM/dd/yyyy';
    }
    const format = AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId)?.name ?? 'MM/dd/yyyy';
    return format.toUpperCase().replace('DD', 'dd').replace('YYYY', 'yyyy');
}

/** Uppercase placeholder for date inputs, e.g. DD/MM/YYYY. */
export function getAppDateFormatPlaceholder(): string {
    return (AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId)?.name ?? 'DD/MM/YYYY').toUpperCase();
}

/** DevExtreme grid column formatter using the company date format. */
export function formatDateForDevExtreme(datePipe: DatePipe, value: string | number | Date | null | undefined): string {
    return datePipe.transform(value, getAppDateFormatPattern()) ?? '';
}

export function convertDecimalTimespanIntoNormalTimeSpan(timespan: string): string {
    if (!timespan) {
        return timespan;
    }
    if (timespan.split(':')[0].includes('.')) {
        const min = parseInt(timespan.split(':')[1], 10);
        const sec = 0;
        const days = parseInt(timespan.split(':')[0].split('.')[0], 10);
        const newHours = parseInt(timespan.split(':')[0].split('.')[1], 10);
        const hours = days < 0 ? days * 24 - newHours : days * 24 + newHours;
        return `${hours < 10 && hours >= 0 ? '0' + hours : hours}:${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
    }
    return timespan;
}

export function formatTimespanShort(timespan: string): string {
    if (!timespan) {
        return '00h 00m';
    }
    const lastIndex = timespan.lastIndexOf('.');
    if (lastIndex > 6) {
        timespan = timespan.substring(0, lastIndex);
    }
    let days = 0;
    if (timespan.includes('.')) {
        days = parseInt(timespan.split('.')[0], 10) * 24;
        if (days) {
            timespan = timespan.split('.')[1];
        }
    }
    const hours = days ? parseInt(timespan.split(':')[0], 10) + days : parseInt(timespan.split(':')[0], 10);
    const min = parseInt(timespan.split(':')[1], 10);
    return `${hours < 10 ? '0' + hours : hours}:${min < 10 ? '0' + min : min} h`;
}

export function formatTimespanLong(timespan: string): string {
    if (!timespan) {
        return '0 hrs 0 min';
    }
    const hours = parseInt(timespan.split(':')[0], 10);
    const min = parseInt(timespan.split(':')[1], 10);
    return `${hours} hrs ${min} min`;
}

export function formatSecondsToHms(timeInSeconds: number): string {
    if (!timeInSeconds) {
        return '00:00:00';
    }
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
    const seconds = timeInSeconds - hours * 3600 - minutes * 60;
    return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
}

export function formatTimerToHrsMinsSec(timer: string): string {
    if (!timer) {
        timer = '00:00:00';
    }
    const hrsStr = timer.split(':')[0];
    const minsStr = timer.split(':')[1];
    const secsStr = timer.split(':')[2];
    const hrs = Math.floor(parseFloat(hrsStr));
    const mins = Math.floor(parseFloat(minsStr));
    const secs = Math.floor(parseFloat(secsStr));

    if (mins === 0 && hrs === 0) {
        return `${secs}s`;
    }
    if (hrs === 0) {
        return `${mins}m`;
    }
    return `${hrs}:${mins < 10 ? '0' + mins : mins} h`;
}

export function formatTrackedTimeShort(timeStamp: string): string {
    if (!timeStamp) {
        return '00h 00m';
    }
    const hours = parseInt(timeStamp.split(':')[0], 10);
    let min = parseInt(timeStamp.split(':')[1], 10);
    if (!min) {
        min = 0;
    }
    return `${hours < 10 ? '0' + hours : hours}:${min < 10 ? '0' + min : min} h`;
}

export function formatTrackedTimeLong(timeStamp: string): string {
    if (!timeStamp) {
        return '00:00 hrs';
    }
    const arr = convertDecimalTimespanIntoNormalTimeSpan(timeStamp).split(':');
    return `${parseInt(arr[0], 10)} hrs ${parseInt(arr[1], 10)} min`;
}
